import { api } from './client';
import type {
  GitHubInstallCompletion,
  GitHubIntegrationStatus,
  GitHubRepoSummary,
  ProjectRepository,
} from '@mycompbox/shared';

export type { GitHubInstallCompletion, GitHubIntegrationStatus, GitHubRepoSummary, ProjectRepository };

export const githubApi = {
  /** `returnTo` is carried through the install link so GitHub's callback lands back there. */
  status: (returnTo?: string) =>
    api.get<{ data: GitHubIntegrationStatus }>(
      returnTo ? `/integrations/github?returnTo=${encodeURIComponent(returnTo)}` : '/integrations/github'
    ),
  completeInstall: (input: { installationId: string; code: string; state: string }) =>
    api.post<{ data: GitHubInstallCompletion }>('/integrations/github/installations', input),
  /** A member asks the organization admins to connect GitHub for a project (429 when repeated too soon). */
  requestAccess: (input: { teamId: string; returnTo?: string }) =>
    api.post<{ data: { sent: boolean } }>('/integrations/github/request-access', input),
  removeInstallation: (installationId: string) =>
    api.delete<undefined>(`/integrations/github/installations/${encodeURIComponent(installationId)}`),
  repositories: () => api.get<{ data: GitHubRepoSummary[] }>('/integrations/github/repositories'),
  projectRepository: (teamId: string) => api.get<{ data: ProjectRepository }>(`/teams/${teamId}/repository`),
  connectRepository: (teamId: string, input: { installationId: string; fullName: string }) =>
    api.put<{ data: ProjectRepository }>(`/teams/${teamId}/repository/github`, input),
  createRepository: (teamId: string, input: { installationId: string; name: string; private: boolean; description?: string }) =>
    api.post<{ data: ProjectRepository }>(`/teams/${teamId}/repository/github`, input),
};
